// Generated prop information for MediaWidget
const propList = [
  "libraryId",
  "mediaId",
  "hideWidget",
  "className",
  "height",
  "width"
];
export default propList;

// Detailed prop information with types
export const propInfo = [
  {
    "name": "libraryId",
    "type": "string",
    "optional": true
  },
  {
    "name": "mediaId",
    "type": "string",
    "optional": true
  },
  {
    "name": "hideWidget",
    "type": "boolean",
    "optional": true
  },
  {
    "name": "className",
    "type": "string",
    "optional": true
  },
  {
    "name": "height",
    "type": "string",
    "optional": true
  },
  {
    "name": "width",
    "type": "string",
    "optional": true
  }
];
